/* eslint-disable react-hooks/rules-of-hooks */
import React, { MutableRefObject, useRef, useState, useEffect } from 'react';

type WPState = {
  width: number;
};

type ComposedProps<T> = T & {
  className?: string;
  style?: Object;
  width?: number;
};

/*
 * A simple HOC that provides facility for listening to container resizes.
 *
 * The Flow type is pretty janky here. I can't just spread `WPProps` into this returned object - I wish I could - but it triggers
 * a flow bug of some sort that causes it to stop typechecking.
 */
export default function WidthProvideRGL<T>(
  ComposedComponent: React.ComponentType<T>
): React.ComponentType<ComposedProps<T>> {
  return (props) => {
    const elementRef = useRef() as MutableRefObject<HTMLDivElement>;
    const [state, setState] = useState<WPState>({ width: 1280 });

    const observer = new ResizeObserver((entries) => {
      setState({ width: entries[0].contentRect.width });
    });

    useEffect(() => {
      if (elementRef.current) {
        observer.observe(elementRef.current!);
      }

      return () => {
        observer.disconnect();
      };
    }, [elementRef.current]);

    return <ComposedComponent innerRef={elementRef} {...props} {...state} />;
  };
}
